<script>
import propertyIconSet from "../package/propertyIconSet.vue";
import FooterSection from "../package/footerSection.vue";
import HeaderSection from "../package/HeaderSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import BreadcrumbAboutUs from "../about/breadcrumbAboutUs.vue";
import AboutUsContent from "../about/aboutUsContent.vue";
import AboutUsImage from "../about/aboutUsImage.vue";
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";
import BreadcrumbHowItWorks from "./breadcrumbHowItWorks.vue";
import HowItWorksContent from "./howItWorksContent.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";

export default {
  name: "howItWorksLayout",
  components: {
    // MobileAppDownload,
    HowItWorksContent,
    BreadcrumbHowItWorks,
    AboutUsImage,
    AboutUsContent,
    BreadcrumbAboutUs,
    DrawerAside,
    HeaderSection,
    FooterSection,
    propertyIconSet
  },
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: How It Works";
  },
  created() {
    document.title = "UNIFI Property: How It Works";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-how-it-works />
        <how-it-works-content />
<!--        <property-icon-set />-->
<!--        <mobile-app-download />-->
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}
</style>



// WEBPACK FOOTER //
// src/components/howItWorks/howItWorksLayout.vue